import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import LandingPage from './pages/LandingPage';
import SchoolPage from './pages/SchoolPage';
import ContactPage from './pages/ContactPage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import TermsOfServicePage from './pages/TermsOfServicePage';
import CommercialTransactionsPage from './pages/CommercialTransactionsPage';
import LoginPage from './pages/LoginPage';
import AccountDeletionPage from './pages/AccountDeletionPage';
import RegisterPage from './pages/RegisterPage';
import NoticeDetailPage from './pages/NoticeDetailPage';
import FAQListPage from './pages/FAQListPage';
import NotFoundPage from './pages/NotFoundPage';
import ScrollToTop from './components/ScrollToTop';
import { initAnalytics, trackPageView } from './utils/analytics';

function AnalyticsBridge() {
  const location = useLocation();

  useEffect(() => {
    // 同意済みなら初期化（未同意なら何もしない）
    initAnalytics();
  }, []);

  useEffect(() => {
    // ルート遷移時のPV送信（未同意なら何もしない）
    trackPageView(location.pathname + location.search);
  }, [location.pathname, location.search]);

  return null;
}

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <AnalyticsBridge />
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/faq" element={<FAQListPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/schools/:schoolId" element={<SchoolPage />} />
        <Route path="/notices/:noticeId" element={<NoticeDetailPage />} />
        <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
        <Route path="/terms-of-service" element={<TermsOfServicePage />} />
        <Route path="/commercial-transactions" element={<CommercialTransactionsPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/account-deletion" element={<AccountDeletionPage />} />
        <Route path="/register" element={<RegisterPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;

